
import { computed, defineComponent, getCurrentInstance, onMounted, ref, watch } from 'vue';
import { sendLog } from '~/common/radar';
import SlideGuideArrow from './icon/slide-guide-arrow.svg';

const SliderGuide = defineComponent({
    props: {
        showCountDown: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const googleStyle = computed(() => {
            if (proxy?.$store?.state?.startup?.ads_open_tough_form_time) {
                return Number(proxy?.$store.state.startup.ads_open_tough_form_time);
            }
            return 0;
        });
        let ads_open_tough_form_time = 0;
        if (proxy?.$store?.state?.startup?.ads_open_tough_form_time) {
            ads_open_tough_form_time = Number(proxy?.$store.state.startup.ads_open_tough_form_time); // number
        }
        const secondsLocal = ref(ads_open_tough_form_time);
        const countDownRef = computed(() => {
            return proxy.$root.$t('swipe_seconds_blank_for_more', { second: secondsLocal.value });
        });
        const defaultTipsRef = computed(() => {
            return proxy.$root.$t('swipe_blank_for_more');
        });

        const beginCountDown = () => {
            if (ads_open_tough_form_time > 0) {
                const timerId = setInterval(() => {
                    if (secondsLocal.value === 0) {
                        clearInterval(timerId);
                        return;
                    }
                    secondsLocal.value -= 1;
                }, 1000);
            }
        };
        onMounted(() => {
            beginCountDown();
        });
        return {
            SlideGuideArrow,
            countDownRef,
            defaultTipsRef,
            beginCountDown,
            googleStyle,
        };
    },
});

export default SliderGuide;
